import React from 'react'

const Spinner = () => {
  return (
    <div className='spinner-new'></div>
  )
}

export default Spinner